import { render } from "./VenueAdminList.vue?vue&type=template&id=da3b8374"
import script from "./VenueAdminList.vue?vue&type=script&lang=js"
export * from "./VenueAdminList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__